import CategoriesEntity from '@/entities/api/categories/categories'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface CategoriesSlice {
	categories: CategoriesEntity[]
}

const initialState: CategoriesSlice = {
	categories: [],
}

const categoriesSlice = createSlice({
	name: 'categories',
	initialState,
	reducers: {
		setCategoriesFn: (state, action: PayloadAction<CategoriesEntity[]>) => {
			state.categories = action.payload
		},
		addCategoryFn: (state, action: PayloadAction<CategoriesEntity>) => {
			state.categories.push(action.payload)
		},
		updateCategoryFn: (state, action: PayloadAction<CategoriesEntity>) => {
			const index = state.categories.findIndex(
				(category) => category._id === action.payload._id
			)
			if (index !== -1) {
				state.categories[index] = action.payload
			}
		},
		deleteCategoryFn: (state, action: PayloadAction<string>) => {
			state.categories = state.categories.filter(
				(category) => category._id !== action.payload
			)
		},
	},
})

export const {
	setCategoriesFn,
	addCategoryFn,
	updateCategoryFn,
	deleteCategoryFn,
} = categoriesSlice.actions

export default categoriesSlice.reducer
